import { LogLevel } from "@azure/msal-browser";

const urlParams = new URLSearchParams(window.location.search);
const customer = urlParams.get('customer');

let clientId = process.env.REACT_APP_CLIENT_ID || '';
let tenantId = process.env.REACT_APP_TENANT_ID || 'common';
let redirectUri = '/?customer=SCGC';
let postLogoutRedirectUri = '/?customer=SCGC';
if (customer && customer.toUpperCase() === 'BST') {
    clientId = process.env.REACT_APP_CLIENT_BST_ID || '';
    tenantId = process.env.REACT_APP_TENANT_BST_ID || 'common';
    redirectUri = '/?customer=BST';
    postLogoutRedirectUri = '/?customer=BST';
}

export const msalConfig = {
    auth: {
        clientId: clientId, // This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/" + tenantId, // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: redirectUri, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: postLogoutRedirectUri, // Indicates the page to navigate after logout.
        clientCapabilities: ["CP1"] // this lets the resource owner know that this client is capable of handling claims challenge.
    },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        // console.info(message);
                        return;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return;
                    case LogLevel.Warning:
                        // console.warn(message);
                        return;
                }
            }
        }
    }
};

export const loginRequest = {
    scopes: ['User.Read']
};